import * as React from 'react';
const MapPinIcon = ({ width = 39, height = 39, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 39 39'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M32.5 16.25c0 9.75-13 19.5-13 19.5s-13-9.75-13-19.5a13 13 0 0 1 26 0'
      stroke='#000'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.5 21.125a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75'
      stroke='#000'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default MapPinIcon;
